var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPending = function SvgIconPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C0D2E7",
    fillOpacity: 0.12,
    d: "M20 5C11.714 5 5 11.716 5 20s6.715 15 15 15 15-6.716 15-15S28.283 5 20 5M1.665 20c0-10.125 8.208-18.333 18.333-18.333 10.126 0 18.334 8.208 18.334 18.333s-8.208 18.333-18.334 18.333S1.666 30.125 1.666 20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.999,
    cy: 20,
    r: 18.333,
    fill: "#C0D2E7",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 9.444c.921 0 1.667.717 1.667 1.6v10.134c0 .883-.746 1.6-1.666 1.6s-1.667-.717-1.667-1.6V11.044c0-.883.746-1.6 1.667-1.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.666 21.111c0 .92-.53 1.667-1.667 1.667H20v-3.334h10c1.137 0 1.667.747 1.667 1.667"
  })));
};
export default SvgIconPending;